const AboutPopup = () => {
    return (<div style={{background: "white", width: "100%", height: "130px", borderRadius: "10px",
                        paddingTop: "30px", marginTop: "20px", float: "left", marginBottom: "10px"}}>
            <p>Any data on this page is made up or unrealisticly altered and must not be taken seriously</p>
            <p>This is a mock-up project used exclusively for AWS training purposes.
                All Data used for this site is fake.
                There is no affiliation with Books of any sort.</p>
            <br/>
            <p> This Page was Coded by Jeffrey Ferguson</p>
            <p>&copy;2022</p>

            </div>
    )
}

AboutPopup.defaultProps = {

}
AboutPopup.propTypes = {
}

export default AboutPopup;